<template>
  <v-dialog v-model="open" :width="modalWidth" :persistent="persistent" :transition="modalTransition">
    <v-card
      class="card-container"
      :class="{ 'no-padding': noDefaultPadding }"
      :style="{
        'min-height': minHeight,
      }"
    >
      <div>
        <v-toolbar
          elevation="0"
          color="background"
          class="fluid-toolbar"
          :class="{
            'no-x-padding': !noDefaultPadding,
            small: smallToolbarPadding,
            'mb-6': !smallToolbarPadding,
          }"
        >
          <v-toolbar-title
            class="text-h6 font-weight-medium mt-2"
            :class="{
              'small-title': smallToolbarPadding,
              'brand--text text--darken-2': !$vuetify.theme.dark,
            }"
          >
            {{ title }}
            <p
              v-if="subtitle"
              class="text-subtitle-1 mb-0"
              :class="{
                'neutral--text text--lighten-1': !$vuetify.theme.dark,
              }"
            >
              {{ subtitle }}
            </p>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items class="align-self-baseline">
            <slot name="beforeCloseBtn"> </slot>
            <v-btn icon @click="handleCallClose" class="no-ripple">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <slot name="content"></slot>
      </div>
      <slot name="card-actions"></slot>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'BaseModal',
  data: () => ({
    open: false,
  }),
  props: {
    noDefaultPadding: {
      type: Boolean,
      default: false,
    },
    persistent: {
      type: Boolean,
      default: false,
    },
    modalTransition: {
      type: String,
      default: 'dialog-transition',
    },
    smallToolbarPadding: {
      type: Boolean,
      default: false,
    },
    modalWidth: {
      type: String,
      default: '800px',
    },
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    hookSufix: {
      type: String,
      default: 'TestModal',
      required: true,
    },
    onOpenHook: {
      type: Function,
    },
    onCloseHook: {
      type: Function,
    },
    minHeight: {
      type: String,
      default: '599px',
    },
  },
  watch: {
    open(val) {
      if (!val) this.handleCallClose()
    },
  },
  computed: {
    openListener() {
      return `open${this.hookSufix}`
    },
    closeListener() {
      return `close${this.hookSufix}`
    },
  },
  beforeDestroy() {
    this.$root.$off(this.openListener)
    this.$root.$off(this.closeListener)
  },
  mounted() {
    this.$root.$on(this.openListener, (emitData) => {
      this.open = true
      if (this.onOpenHook) this.onOpenHook(emitData)
    })
    this.$root.$on(this.closeListener, () => {
      this.handleClose()
    })
  },
  methods: {
    handleClose(emitData) {
      this.open = false
      if (this.onCloseHook) this.onCloseHook(emitData)
    },
    handleCallClose() {
      this.$root.$emit(this.closeListener)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/src/_ai_works';
</style>

<style lang="scss">
.not-allowed {
  cursor: not-allowed !important;
}
.no-x-padding {
  .v-toolbar__content {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}
.v-dialog {
  overflow: auto !important;
}
.fluid-toolbar {
  height: unset !important;
  .v-toolbar__content {
    height: unset !important;
  }

  &.small {
    height: unset !important;

    .v-toolbar__content {
      height: unset !important;
      padding: 16px 24px 24px 24px;
    }
  }
  &:not(.small) {
    .v-toolbar__content {
      padding: 24px 32px 0px 32px;
    }
  }
}

.v-application .small-title.text-h6 {
  font-size: 18px !important;
}
</style>

<style lang="scss" scoped>
.card-container {
  max-height: 90vh;
  > div {
    max-height: inherit;
  }
  ::v-deep * {
    font-family: Rubik !important;
  }
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .v-toolbar__content,
  .v-toolbar__items,
  .v-toolbar__items > button {
    height: unset !important;
    width: auto !important;
  }

  &:not(.no-padding) {
    padding: 0px 32px 0px 32px !important;
  }
}

.v-btn.no-ripple::before {
  display: none;
}
</style>
